(function () {
    'use strict'

    angular.module('MktzapApp.Factories')
        .factory('AttendanceIdentificationService', AttendanceIdentificationService);

    AttendanceIdentificationService.$inject = ['$resource'];

    function AttendanceIdentificationService($resource) {
        return $resource('', {}, {
            paged: {
                url: apiUrl + '/security/attendance-identification-search',
                method: 'GET',
                params: {},
                isArray: false
            },
            getAllCompanies: {
                url: apiUrl + '/security/attendance-identification-getallcompanies',
                method: 'GET',
                params: {},
                isArray: false
            },
        })
    }
})();
